import React, { useState } from "react";
import { IndianRupee, Wallet, ArrowUpRight, Clock, Send } from "lucide-react";

const PayoutRequest = () => {
  const [amount, setAmount] = useState("");

  const payoutHistory = [
    {
      id: "PAYOUT-001",
      amount: "₹12,000",
      status: "Completed",
      date: "10 Nov 2025",
    },
    {
      id: "PAYOUT-002",
      amount: "₹5,500",
      status: "Pending",
      date: "05 Nov 2025",
    },
    {
      id: "PAYOUT-003",
      amount: "₹9,000",
      status: "Rejected",
      date: "01 Nov 2025",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Payout Requested: ₹${amount}`);
    setAmount("");
  };

  return (
    <div className="p-4">
      {/* Title */}
      <h1 className="text-2xl font-bold mb-6">Payout Requests</h1>

      {/* Top Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">

        <div className="bg-white shadow rounded-xl p-4 flex items-center gap-4">
          <Wallet className="text-blue-600" size={40} />
          <div>
            <p className="text-gray-500">Available Balance</p>
            <h2 className="text-2xl font-bold">₹18,500</h2>
          </div>
        </div>

        <div className="bg-white shadow rounded-xl p-4 flex items-center gap-4">
          <ArrowUpRight className="text-green-600" size={40} />
          <div>
            <p className="text-gray-500">Total Payouts</p>
            <h2 className="text-2xl font-bold">₹1,45,350</h2>
          </div>
        </div>

        <div className="bg-white shadow rounded-xl p-4 flex items-center gap-4">
          <Clock className="text-orange-600" size={40} />
          <div>
            <p className="text-gray-500">Pending Requests</p>
            <h2 className="text-2xl font-bold">₹5,500</h2>
          </div>
        </div>

      </div>

      {/* Request Form */}
      <div className="bg-white shadow rounded-xl p-6 mb-6 border">
        <h2 className="text-xl font-semibold mb-4">Request New Payout</h2>

        <form className="grid grid-cols-1 md:grid-cols-3 gap-4" onSubmit={handleSubmit}>
          
          {/* Amount Input */}
          <div className="flex flex-col md:col-span-2">
            <label className="font-medium">Enter Amount (₹)</label>
            <input
              type="number"
              className="border p-2 rounded-lg"
              placeholder="Eg. 5000"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
          </div>

          {/* Submit Button */}
          <div className="md:col-span-1 flex items-end">
            <button
              type="submit"
              className="bg-blue-600 w-full text-white px-4 py-3 rounded-lg shadow hover:bg-blue-700 flex items-center justify-center gap-2 transition"
            >
              <Send size={18} /> Request Payout
            </button>
          </div>

        </form>
      </div>

      {/* Payout History Table */}
      <div className="bg-white shadow rounded-xl p-6 border">
        <h2 className="text-xl font-semibold mb-4">Payout History</h2>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="p-3 text-left">Payout ID</th>
                <th className="p-3 text-left">Amount</th>
                <th className="p-3 text-left">Status</th>
                <th className="p-3 text-left">Date</th>
              </tr>
            </thead>

            <tbody>
              {payoutHistory.map((item) => (
                <tr key={item.id} className="border-b hover:bg-gray-50 transition">
                  <td className="p-3 font-medium">{item.id}</td>
                  <td className="p-3">{item.amount}</td>
                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${
                        item.status === "Completed"
                          ? "bg-green-100 text-green-700"
                          : item.status === "Pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td className="p-3">{item.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default PayoutRequest;
